import { Route } from 'react-router-dom';
import { lazyPage } from './lazyPage';

const StaffHome = lazyPage(() => import('../pages/staff/Home'), 'Home');
const Notifications = lazyPage(() => import('../pages/staff/Notifications'), 'Notifications');
const UnifiedSettings = lazyPage(() => import('../pages/staff/settings/UnifiedSettings'), 'UnifiedSettings');
const PositionManagement = lazyPage(() => import('../pages/staff/settings/PositionManagement'), 'PositionManagement');

/** Home, notifications and settings: any staff member. */
export const staffRoutes = (
  <>
    {/* Staff Home: post-login landing for staff and admins (#377) */}
    <Route path="/staff/home" element={<StaffHome />} />
    <Route path="/staff/notifications" element={<Notifications />} />
    <Route path="/staff/settings" element={<UnifiedSettings />} />
    <Route path="/staff/settings/positions" element={<PositionManagement />} />
  </>
);
